import * as types from "./types";

import { 
    getDeliveryNotesListAxios,
    deleteDeliveryNotesAxios,
    postDeliveryNotesAxios,
    putDeliveryNotesAxios,
    getDeliveryNotesByIDAxios,
    getAllDeliveryNotesListAxios,
    getDeliverySignatureIDAxios,
    postDeliverySignatureAxios,
} from "./services";

export async function getDeliveryNotesListAction({commit}, id) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        const {data} = await getDeliveryNotesListAxios(id);
        commit(types.GET_DELIVERYNOTES_LIST, data.result);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function deleteDeliveryNotesAction({commit}, payload) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        await deleteDeliveryNotesAxios(payload);
        commit(types.REMOVE_DELIVERYNOTES, payload);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function addDeliveryNotesAction({commit}, payload) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        const {data} = await postDeliveryNotesAxios(payload);
        payload.id = data.id;
        commit(types.ADD_DELIVERYNOTES, payload);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function updateDeliveryNotesAction({commit}, payload) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        await putDeliveryNotesAxios(payload);        
        commit(types.UPDATE_DELIVERYNOTES, payload);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function getDeliveryNotesByIDAction({commit}, payload) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        const { data } = await getDeliveryNotesByIDAxios(payload);
        console.log('fy', data.result)
        commit(types.GET_DELIVERYNOTESBYIDINVOICE, data.result);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function getAllDeliveryNoteListAction({commit}) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        const {data} = await getAllDeliveryNotesListAxios();
        commit(types.GET_DELIVERYNOTES_LIST, data.result);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function getDeliverySignatureByIDAction({commit}, id) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        const {data} = await getDeliverySignatureIDAxios(id);
        commit(types.GET_DELIVERYBYID_SIGNATURE, data.result);
        return data.result;
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERYNOTES, false);
}

export async function addDeliverySignatureAction({commit}, payload) {
    commit(types.LOADING_DELIVERYNOTES, true);
    try {
        const {data} = await postDeliverySignatureAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_DELIVERY_SIGNATURE, payload);
        return data;
    }
    catch(e) {
        console.log(e);
    }
    finally {
        commit(types.LOADING_DELIVERYNOTES, false);
    }
}